export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const PROGRAM_TYPES = {
  LIVE: 'live-classes',
  VWOD: 'recorded-trainings',
  CUSTOM: 'custom-trainings',
};

export const ALERT_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};

export const MODAL_NAMES = {
  SIGN_UP: 'SIGN_UP',
  SIGN_IN: 'SIGN_IN',
  GET_IN_TOUCH: 'GET_IN_TOUCH',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  CONEKTA_3DS: 'CONEKTA_3DS',
};

export const DRAWERS = {
  appoinment: 'appoinment',
  addCard: 'addCard',
  checkout: 'checkout',
  indications: 'indications',
  schedule: 'schedule',
  paymentSubscription: 'paymentSubscription',
  nutritionistAppointment: 'nutritionistAppointment',
  appointmentConfirmation: 'appointmentConfirmation',
};

export const DAY_NAMES = {
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
};

export const FITNESS_LEVELS = {
  beginner: 'Principiante',
  intermediate: 'Intermedio',
  advanced: 'Avanzado',
};

export const DISCIPLINES = {
  martialArts: 'Artes marciales',
  dance: 'Danza',
  barre: 'Barre',
  box: 'Box',
  calistenia: 'Calistenia',
  functionalTraining: 'Funcional',
  hiit: 'Hiit',
  pesas: 'Pesas',
  pilates: 'Pilates',
  yoga: 'Yoga',
  zumba: 'Zumba',
};

export const BENEFITS = {
  agility: 'Agilidad',
  lowImpact: 'Bajo impacto',
  cardiovascular: 'Cardiovascular',
  strength: 'Fuerza',
  muscle: 'Músculo',
  lossFat: 'Pérdida de grasa',
  prenatal: 'Pernatal',
  resistance: 'Resistencia',
  withoutMaterial: 'Sin material',
};

export const PAYPAL_CLIENT_ID =
  process.env.NODE_ENV === 'production'
    ? 'Ae0JWnb8lBzDMefOZCMWVC5J7B1h8n3dmZ6mYJcEc6nzHome4hYUcPdOdTY_1I5yHq3u9OdMH-hwVDRi'
    : 'AQNpKzBdCpbSh5bkz4WpKRRcz_ehtgrFg3dIfGXaXdI-nzlbUn-bkOcxPJXrIQAFhBL9sUP1iDdI_NKJ';

export const YEARS = [
  { name: '2023', value: '2023' },
  { name: '2024', value: '2024' },
  { name: '2025', value: '2025' },
  { name: '2026', value: '2026' },
  { name: '2027', value: '2027' },
  { name: '2028', value: '2028' },
  { name: '2029', value: '2029' },
  { name: '2030', value: '2030' },
  { name: '2031', value: '2031' },
  { name: '2032', value: '2032' },
  { name: '2033', value: '2033' },
  { name: '2034', value: '2034' },
  { name: '2035', value: '2035' },
];

export const MONTHS = [
  { name: 'Enero', value: '01' },
  { name: 'Febrero', value: '02' },
  { name: 'Marzo', value: '03' },
  { name: 'Abril', value: '04' },
  { name: 'Mayo', value: '05' },
  { name: 'Junio', value: '06' },
  { name: 'Julio', value: '07' },
  { name: 'Agosto', value: '08' },
  { name: 'Septiembre', value: '09' },
  { name: 'Octubre', value: '10' },
  { name: 'Noviembre', value: '11' },
  { name: 'Diciembre', value: '12' },
];

export const WELLNUB_PHONE = '5621868662';